// noinspection NpmUsedModulesInstalled,ES6CheckImport
import React from 'react'
// noinspection NpmUsedModulesInstalled,ES6CheckImport
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { Container, Icon, Label } from 'semantic-ui-react'

import Title from '../components/title'
import 'semantic-ui-css/semantic.min.css';
import './index.css'

const Layout = ({children, data}) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        {name: 'description', content: 'Cristian Castiblanco - Curriculum Vitae'},
        {name: 'keywords', content: 'cv'},
      ]}>
    </Helmet>
    <Container text className='main'>
      <Title siteTitle={data.site.siteMetadata.title}/>
      {children()}
      <Label href="https://docs.google.com/viewer?url=https://docs.google.com/document/d/1YswzB6fq565YZsAaA8dg0B00qk1SiSCPyMCm8720rgA/export?format=pdf" as='a' className='download-pdf'>
        <Icon name='download' /> Download PDF version
      </Label>
    </Container>
  </div>
);

Layout.propTypes = {
  children: PropTypes.func,
};

export default Layout;

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js